import { connect } from 'react-redux'

import AreaOptions from '../../components/qa-servicings/qa-servicing-options'

import {
  fetchQAServicing,
  completeQAServicing,
  deleteQAServicing
} from '../../actions/qa-servicings'

function mapStateToProps (state, ownProps) {
  const qaServicingId = ownProps.qaServicingId
  const qaServicing = state.qaServicings[qaServicingId]

  return {
    qaServicing
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const qaServicingId = ownProps.qaServicingId

  return {
    loadPermissions () {
      dispatch(fetchQAServicing(qaServicingId))
    },

    deleteQAServicing () {
      dispatch(deleteQAServicing(qaServicingId))
    },

    completeQAServicing () {
      dispatch(completeQAServicing(qaServicingId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaOptions)



// WEBPACK FOOTER //
// ./src/containers/qa-servicings/qa-servicing-options-container.js